import { createRoot } from "react-dom/client";
import { setupBridgeABTest, setupChunkErrorRecovery } from "@/lib/api-utils";
import App from "./App.tsx";
import "./index.css";

setupBridgeABTest();
setupChunkErrorRecovery();

createRoot(document.getElementById("root")!).render(<App />);

